<ngx-loading [show]="show" [config]="animationType()"></ngx-loading>